import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  Erc721Section,
  Erc721Contract,
  Erc721Template,
  Erc721Token,
  IndexWrapper,
  ServiceType,
} from "@framework/shared";

export const erc721Routes: Array<RouteObject> = [
  {
    path: "/erc721",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="erc721">
            <Erc721Section />
          </IndexWrapper>
        ),
      },
      {
        path: "/erc721/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <Erc721Contract service={ServiceType.ADMIN} /> },
          { path: "/erc721/contracts/:id/:action", element: <Erc721Contract service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/erc721/templates",
        element: <Protected />,
        children: [
          { index: true, element: <Erc721Template service={ServiceType.ADMIN} /> },
          { path: "/erc721/templates/:id/:action", element: <Erc721Template service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/erc721/tokens",
        element: <Protected />,
        children: [
          { index: true, element: <Erc721Token service={ServiceType.ADMIN} /> },
          { path: "/erc721/tokens/:id/:action", element: <Erc721Token service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
